import { render, staticRenderFns } from "./ActivityTimeLineItemComment.vue?vue&type=template&id=203e7ec3&"
import script from "./ActivityTimeLineItemComment.vue?vue&type=script&lang=ts&"
export * from "./ActivityTimeLineItemComment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VList})
